const state = {
    riskPolicy: '',
};

const mutations = {
    setRiskPolicy(state, value) {
        state.riskPolicy = value;
    },
};

const actions = {};

const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
